export class StorageKeys {
    static readonly SUBSCRIPTION_LEVEL = 'subscriptionLevel';
    static readonly SESSION_TOKEN = 'sessionToken';
    static readonly PREFERRED_METHOD_OF_LOGIN = 'preferredMethodOfLogin';
    static readonly ATTEMPTED_METHOD_OF_LOGIN = 'attemptedMethodOfLogin';
    static readonly LAST_LOGGED_IN_USER = 'lastLoggedInUser';

}